var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconLinkToCloud({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "link-24px",
    xmlns: "http://www.w3.org/2000/svg",
    x: "0px",
    y: "0px",
    viewBox: "0 0 20 20",
    style: {
      enableBackground: "new 0 0 20 20"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Pfad_3362",
    className: "st0",
    d: "M3.25,10c0.0011032-1.4266462,1.1573534-2.5828962,2.5839996-2.5839996h3.3330002V5.8330002 H5.8339996c-2.3010943,0.0356417-4.1376066,1.9299412-4.101965,4.2310352 c0.0348635,2.2508535,1.8511114,4.0671015,4.101965,4.101965h3.3330002v-1.5830002H5.8339996 C4.407743,12.5818977,3.2516541,11.4262562,3.25,10z M6.6669998,10.8330002h6.6669998V9.1660004H6.6669998V10.8330002z  M14.1669998,5.8330002h-3.3330002v1.5830002h3.3330002c1.4268274,0,2.5834999,1.1566725,2.5834999,2.5834999 s-1.1566725,2.5834999-2.5834999,2.5834999h-3.3330002v1.5830002h3.3330002 c2.3010941,0.0356417,4.1953926-1.8008709,4.2310352-4.101965c0.0356407-2.3010941-1.8008709-4.1953936-4.101965-4.2310352 C14.2530489,5.8323336,14.210021,5.8323336,14.1669998,5.8330002z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconLinkToCloud);
export default __webpack_public_path__ + "static/media/Icon_LinkToCloud.c5da5df5f9bf50b5eb00b951e36645fc.svg";
export { ForwardRef as ReactComponent };